import { $http } from '@/utils/https';

export type IFilter = {
  catalog_type?: string;
  sort_filter_type?: string;
  brands?: string;
  series?: string;
  categories?: string;
};
interface State {
  filters: Array<IFilter>;
}

const state: State = {
  filters: []
};

const getters = {
  filters: (state: State) => state.filters
};

const actions = {
  GET_FILTERS: async ({ commit }: any) => {
    let url = `v1/selection/get_filters`;
    try {
      const response = await $http.get(url);
      commit('SET_FILTERS', response.data.data);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {
  SET_FILTERS(state: any, data: Array<IFilter>) {
    state.filters = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
